const css = `.compact-employee-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
}
.compact-employee-item .compact-employee-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--surface-ground);
  font-size: var(--font-size-sm);
  color: var(--text-color);
}
.compact-employee-item .compact-employee-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.compact-employee-item .compact-employee-avatar span {
  font-weight: var(--font-weight-medium);
  text-transform: uppercase;
}
.compact-employee-item .compact-employee-name {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: inherit;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.compact-employee-panel .p-dropdown-filter-container {
  padding: 4px !important;
  position: relative;
}
.compact-employee-panel .p-dropdown-filter-container .p-dropdown-filter {
  padding: 4px 8px !important;
  width: 100%;
  font-size: var(--font-size-base);
  border-radius: 4px;
  border: 1px solid var(--surface-border);
  height: 32px;
}
.compact-employee-panel .p-dropdown-filter-container .p-dropdown-filter:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 1px var(--accent-subtle);
}
.compact-employee-panel .p-dropdown-filter-container .p-dropdown-filter-icon {
  position: absolute;
  right: 12px !important;
  top: 50%;
  transform: translateY(-50%);
  font-size: var(--font-size-base);
  color: var(--text-color-secondary);
  margin: 0;
}
.compact-employee-panel .p-dropdown-items {
  padding: 4px !important;
  max-height: 200px;
}
.compact-employee-panel .p-dropdown-item {
  border-radius: 4px;
  margin-bottom: 2px;
  padding: 4px 8px;
  min-height: 36px;
  font-size: var(--font-size-base) !important;
}
.compact-employee-panel .p-dropdown-item:last-child {
  margin-bottom: 0;
}
.compact-employee-panel .p-dropdown-item.p-highlight {
  background-color: var(--accent-subtle) !important;
  color: var(--accent) !important;
}
.compact-employee-panel .p-dropdown-item:hover {
  background-color: var(--surface-hover);
}
.compact-employee-panel .p-dropdown-empty-message {
  padding: 8px;
  font-size: var(--font-size-base);
  color: var(--text-color-secondary);
  text-align: center;
}

.compact-employee-name {
  font-size: var(--font-size-base) !important;
  font-weight: var(--font-weight-medium);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
